import React, { useEffect, useState } from 'react'
import Heading from '../../../../component/common/Heading'
import useHttp from '../../../../hooks/use-http'
import { useParams } from 'react-router-dom'
import { apiGenerator } from '../../../../util/functions'
import CONSTANTS from '../../../../util/constant/CONSTANTS'

const DeviceDetails = () => {
    const [device, setDevice] = useState({})
    const { id } = useParams()
    const api = useHttp()

    console.log(device);

    useEffect(() => {
        const PET_DEVICE_API = apiGenerator(CONSTANTS.API.Pet_Device_Details.getAll, {}, `?petId=${id}`)
        console.log(PET_DEVICE_API);
        api.sendRequest(PET_DEVICE_API, (res) => {
            setDevice(res?.data?.rows)
        })
    }, [])
    return (
        <>
            <div>
                <Heading>Device Details</Heading>
                {Object.keys(device).length > 0 ?
                    <div className='mt-5'>
                        <p className='text-base font-medium py-2'> Device Id : {device[0]?.device?.uniqueId || '-'}</p>
                        <p className='text-base font-medium py-2'> Is Device Active : {device[0]?.device?.isActive ? 'Yes' : 'No'}</p>
                        <p className='text-base font-medium py-2'> Device Type : {device[0]?.device?.deviceType?.title || '-'}</p>
                    </div> :
                    <>
                        <p className='text-base mt-5 text-red-600 font-medium py-2'>Pet is not connected with device</p></>}

            </div>
        </>
    )
}

export default DeviceDetails